import { Suspense, useEffect, useState } from "react";

// react-router components
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

// @mui material components
import CssBaseline from "@mui/material/CssBaseline";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from "@mui/material/styles";

// Argon Dashboard 2 MUI example components
import Sidenav from "examples/Sidenav";

// Argon Dashboard 2 MUI themes
import theme from "assets/theme";

// Argon Dashboard 2 MUI routes
import routes from "routes";

// Argon Dashboard 2 MUI contexts
import { setMiniSidenav, useArgonController } from "context";
import { AuthProvider, useAuth } from "context/AuthContext";
import { UserProvider } from "context/UserContext";
import ProtectedRoute from "components/ProtectedRoute";

// Images
import brandDark from "assets/images/logo-ct-dark.png";

// Icon Fonts
import "assets/css/nucleo-icons.css";

function AppContent() {
  const [controller, dispatch] = useArgonController();
  const { miniSidenav, layout } = controller;
  const { user } = useAuth();
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  const showSidenav = Boolean(user) && layout === "dashboard";

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.route) {
        // Proteger todas las rutas excepto sign-in
        const isSignInRoute = route.route === "/authentication/sign-in";
        const element = isSignInRoute ? (
          route.component
        ) : (
          <ProtectedRoute>{route.component}</ProtectedRoute>
        );

        return <Route exact path={route.route} element={element} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {showSidenav && (
        <Sidenav
          brand={brandDark}
          brandName="PayFlex"
          routes={routes}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
      )}
      <Suspense
        fallback={
          <LinearProgress
            color="info"
            sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999 }}
          />
        }
      >
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <UserProvider>
        <AppContent />
      </UserProvider>
    </AuthProvider>
  );
}
